import { OrderStateEnum } from '../../../generated/internal.graphql';

/**
 * The internal schema's order states, keyed off the generated `OrderStateEnum` so a backend rename
 * is a compile error here rather than a silently dead comparison at a call site.
 *
 * Deliberately not shared with `App/Order/OrderState`: the two namespaces track two independent
 * schemas, and coupling them would let an AppSchema change reshape the staff screens.
 */
export const OrderState = Object.freeze({
  DRAFT: OrderStateEnum.Draft,
  AWAITING_PAYMENT: OrderStateEnum.AwaitingPayment,
  COMPLETED: OrderStateEnum.Completed,
});
export type OrderState = (typeof OrderState)[keyof typeof OrderState];

/**
 * The schema types `state` as a bare `String!` while the *filter* uses `OrderStateEnum`. Narrow it
 * once, here, so pages compare against the union instead of stringly-typed literals.
 *
 * It lives beside the enum rather than in `Order.ts` because both read shapes need it, and having
 * `OrderDetail` import it from `Order` would couple the two modules for a one-line cast.
 */
export const toOrderState = (state: string): OrderState => state as OrderState;
